import React, { useEffect, useRef } from 'react';

const Features = () => {
  const featureRefs = useRef([]);

  useEffect(() => {
    // Capture the current snapshot of refs
    const refsSnapshot = featureRefs.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    // Setup using refsSnapshot
    refsSnapshot.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    // Cleanup uses the same snapshot, not featureRefs.current directly
    return () => {
      refsSnapshot.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  const features = [
    {
      icon: '⚡',
      title: '초고속 전송',
      description: '평균 3초 이내 전 세계 어디든 문자를 전송합니다'
    },
    {
      icon: '🔒',
      title: '안전한 보안',
      description: '엔터프라이즈급 암호화로 데이터를 안전하게 보호합니다'
    },
    {
      icon: '📊',
      title: '실시간 통계',
      description: '전송 현황과 통계를 실시간으로 확인할 수 있습니다'
    },
    {
      icon: '🌐',
      title: '글로벌 커버리지',
      description: '200개 이상의 국가와 지역을 지원합니다'
    },
    {
      icon: '💼',
      title: 'API 연동',
      description: '간편한 API로 시스템에 쉽게 통합할 수 있습니다'
    },
    {
      icon: '🎯',
      title: '정확한 전달',
      description: '99.9%의 높은 전송 성공률을 보장합니다'
    }
  ];

  return (
    <section id="features" className="features">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">왜 Global SMS를 선택해야 할까요?</h2>
          <p className="section-description">안정적이고 빠른 해외 문자 발송 서비스의 모든 것</p>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div
              key={index}
              ref={(el) => (featureRefs.current[index] = el)}
              className="feature-card"
            >
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
